import React from 'react';

import { EditorState, type Extension } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { Box, type SxProps } from '@mui/material';
import { MONOSPACE_FONT_FAMILY } from '@wp-constants/fontFamilies';

type BaseCodeMirrorProps = {
  sx?: SxProps;
  defaultValue: string | undefined | null;
  extensions?: Extension[];
  onChange?: (value: string) => void;
};

export default class BaseCodeMirror extends React.Component<BaseCodeMirrorProps> {
  private containerRef: React.RefObject<HTMLDivElement>;

  constructor(props: BaseCodeMirrorProps) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount(): void {
    if (!this.containerRef.current) {
      return;
    }

    const extensions = [...(this.props.extensions ?? [])];
    const onChange = this.props.onChange;
    if (onChange) {
      extensions.push(
        EditorView.updateListener.of((vu) => {
          if (vu.docChanged) {
            onChange(vu.state.doc.toString());
          }
        })
      );
    }

    new EditorView({
      parent: this.containerRef.current,
      state: EditorState.create({
        doc: this.props.defaultValue ?? undefined,
        selection: { anchor: 0 },
        extensions,
      }),
    });
  }

  render() {
    return (
      <Box
        ref={this.containerRef}
        sx={{
          '& .cm-editor .cm-scroller': {
            fontFamily: MONOSPACE_FONT_FAMILY,
            fontSize: 13,
          },
          ...this.props.sx,
        }}
      />
    );
  }
}
